import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Image from "components/atoms/Image";

import { Howl } from "howler";

import DominoLetters from "components/atoms/DominoLetters";
import Hint from "components/atoms/Hint";
import {
  getTransliteratedId,
  getWordBySyllable,
  splitBySyllables,
  isNotConsonant,
} from "utils/Language/LanguageAnalysis";
import "./styles.scss";

const Domino = (props) => {
  const [state, setState] = useState({
    syllablesArray: [],
    ...props,
  });

  useEffect(() => {
    let syllablesArray = props?.syllables
      ? splitBySyllables(props?.syllables)
      : null;
    setState({
      ...state,
      ...{
        syllablesArray,
        keysCunningMode: props?.keysCunningMode,
      },
    });
  }, [props?.keysCunningMode, props?.syllables]);

  const onPlaySound = (src) => {
    const sound = new Howl({ src, html5: true });
    props?.shouldRenderSound && sound.once('load', function(){
      sound.play();
    });
  };

  const toggleKeysCunningMode = () => {
    setState({
      ...state,
      ...{ keysCunningMode: !state.keysCunningMode },
    });
  };

  const cunningModeClass = state?.keysCunningMode ? " cunning-mode-on" : "";
  return props?.syllables ? (
    <div>
      <ul className={"domino-images " + props?.size + cunningModeClass}>
        {state?.keysCunningMode && (
          <div
            className="cunning-mode-overlay"
            onClick={toggleKeysCunningMode}
            alt="Показати ключі й відповіді"
            title="Показати ключі й відповіді"
          />
        )}
        {state?.syllablesArray?.map((syllable, index) => {
          const transliteratedId = getTransliteratedId(syllable);
          const audioURL = `https://www.rebusmetod.com/wp-content/themes/whiteboard/sounds/mp3/${transliteratedId}01.mp3`;
          return (
            <li
              key={syllable + index}
              onClick={() => onPlaySound(audioURL)}
            >
              {isNotConsonant(syllable) && (
                <Image filename={transliteratedId} />
              )}
              <DominoLetters
                text={syllable?.toUpperCase()?.replace("1", "")}
                size={props?.size}
                isConsonant={isNotConsonant(syllable) ? "" : " consonant"}
              />
              <Hint text={getWordBySyllable(syllable)} shaded={false} />
            </li>
          );
        }, this)}
      </ul>
    </div>
  ) : null;
};

Domino.propTypes = {
  syllables: PropTypes.string,
  keysCunningMode: PropTypes.bool,
  toggleCardCunningMode: PropTypes.func,
};

export default Domino;
